import { render, staticRenderFns } from "./CouponEdit.vue?vue&type=template&id=3b3ec717&scoped=true&"
import script from "./CouponEdit.vue?vue&type=script&lang=js&"
export * from "./CouponEdit.vue?vue&type=script&lang=js&"
import style0 from "./CouponEdit.vue?vue&type=style&index=0&id=3b3ec717&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ec717",
  null
  
)

export default component.exports